// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AMWDv5eeWVTJEAwEZbJwq{\n    min-height: 100vh;\n}\n    .AMWDv5eeWVTJEAwEZbJwq h2{    \n    }\n._6FPwYozzz8WId1OwpLu8T{\n    position: fixed;\n    bottom: 2%;\n    right: 39.5%\n\n}", "",{"version":3,"sources":["webpack://./src/components/game/Game.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AAGrB;IAFI;IACA;AAEJ;IACI,eAAe;IACf,UAAU;IACV;;AAEJ","sourcesContent":[".content{\n    min-height: 100vh;\n    h2{    \n    }\n}\n.username{\n    position: fixed;\n    bottom: 2%;\n    right: 39.5%\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": "AMWDv5eeWVTJEAwEZbJwq",
	"username": "_6FPwYozzz8WId1OwpLu8T"
};
export default ___CSS_LOADER_EXPORT___;
